import { darken } from 'polished';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
 :root {
  --radius: 10px;
 }
 #root, body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background-color:${({ theme }) => theme.colors.fill};
 }

 * {
  box-sizing: border-box;
 }

   ${({ theme }) => theme.media.md} {
    h1 {
      font-size: 48px;
      line-height: 55px;
    }
    h2 {
      font-size: 38px;
      line-height: 45px;
    }
  }

  ${({ theme }) => theme.media.lg} {
    h1 {
      font-size: 58px;
      line-height: 1.2em;
    }
  }
  ${({ theme }) => theme.media.xl} {
    h1 {
      font-size: 72px;
      line-height: 1.2em;
    }
    h2 {
      font-size: 48px;
      line-height: 52px;
    }
  }

    a {
    color: ${({ theme }) => darken(0.2, theme.colors.accent)};
    text-decoration: none;
    &:hover, &:focus, &:visited {
      color: ${({ theme }) => darken(0.3, theme.colors.accent)};
    }
    &:focus-visible {
      outline: 1px solid ${({ theme }) => theme.colors.accent};
    }
  }

  .cursor-pointer {
    cursor: pointer;
  }
  .cursor-none {
    cursor: initial;
  }

  .w-100 {
    width: 100%;
  }
`;

export const LIGHT_BLUE = '#013777';
